<template>
  <div v-show="isShow">
    <div class="sp-mask"></div>
    <div class="sp-panel">
      <div class="sp-title">
        <h1>多路段共享</h1>
        <button @click="hidePanel">×</button>
      </div>
      <button class="sp-new" @click="addRoad">+ 新增路段</button>
      <div class="sp-wrap">
        <div class="sp-item" v-for="(item, index) in roadsData" :key="index">
          <h2>{{ index + 1 }}</h2>
          <p>
            <span>
              起点
              <p>{{ item.address_start }}</p>
            </span>
            <span>
              终点
              <p>{{ item.address_end }}</p>
            </span>
          </p>
          <div class="sp-item-card" v-if="item.transit">
            <p>{{ "路程为：" + item.transit.distance }}</p>
            <p>{{ "时长为：" + item.transit.duration }}</p>
          </div>
        </div>
      </div>
      <div class="sp-msg">
        <div class="item">
          <p class="item-title">留言</p>
          <textarea type="text" class="item-textarea" v-model="userMessage" />
        </div>
      </div>
      <div class="sp-footer">
        <div class="marked-opera">
          <!-- <button id="link-copy" @click="copyMarkedLink">
            <span></span> 复制标记链接
          </button>
          <button id="link-share"><span></span> 分享</button> -->
          <button id="marked-save" @click="handleSave">
            <span></span> 保存标记
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["roadsData"],
  data() {
    return {
      isShow: false,
      userMessage: "",
    };
  },
  methods: {
    showPanel() {
      this.isShow = true;
      console.log(this.roadsData);
    },
    hidePanel() {
      this.isShow = false;
    },
    addRoad() {
      this.hidePanel();
      this.$emit("showFinishRoadBtn");
    },
    copyMarkedLink() {
      let oURI = document.createElement("input");
      let roadsList = JSON.stringify(...this.roadsData);
      oURI.value = `http://map.ayane.io/?roadsList=${roadsList}`;
      document.body.appendChild(oURI);
      oURI.select();
      document.execCommand("Copy");
      document.body.removeChild(oURI);
      alert("复制成功");
    },
    handleSave() {
      let _this = this;
      let roadsList = this.roadsData;
      alert(roadsList);
      let message = this.userMessage;
      alert(message);
      this.$http
        .post("/service/addRoads", {
          type: "roads",
          roadsList,
          message,
        })
        .then(function (oRes) {
          oRes = oRes.data;
          var link = `http://map.ayane.io/?ms=${oRes.id}`;
          _this.hidePanel();
          _this.$emit("openCopyCard", link);
          console.log(oRes);
          alert(oRes);
          // oURI.value = `localhost:8080/?ms=${oRes.id}`;
          // document.body.appendChild(oURI);
          // oURI.select();
          // document.execCommand("Copy");
          // document.body.removeChild(oURI);
          // alert("复制成功");
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/ShareRoads.less";
</style>
